import React from 'react'

function ShowText(props){
    const {showText, showAuthor, toastStyle} = props
    return (
      <div className="container grid-md pt-2" style={{
          margin: "40px auto auto auto"
        }} key={1}>
        <div className="columns">
          <div className="column col-12">
            <div className={toastStyle}>
              <h5 lang="zh-Hans" style={{
                  margin: "7px auto"
                }}>&nbsp;&nbsp;&nbsp;&nbsp;{showText}</h5>
              <cite lang="zh-Hans">&nbsp;&nbsp;&nbsp;&nbsp;{showAuthor}</cite>
            </div>
          </div>
        </div>
        <div className="divider"></div>
      </div>
    )

}

export default ShowText



// WEBPACK FOOTER //
// ./src/textModule/ShowText.js